import { faFileContract } from "@fortawesome/pro-light-svg-icons";
import DashboardCard, { DashboardCardValueContent } from "../DashboardCard";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { useEffect } from "react";
import {
  getDocuments,
  selectDocuments,
  selectLoadingDocuments,
} from "app/modules/documents/components/DocumentsTableSlice";
import { ClientPortalDocumentFiltersModel } from "services/api/cplapi/CPLAPI";
import { useSelector } from "react-redux";

const YourDocumentsCard = () => {
  const thunkDispatch = useThunkDispatch();
  const documents = useSelector(selectDocuments);
  const loadingDocuments = useSelector(selectLoadingDocuments);

  useEffect(() => {
    thunkDispatch(getDocuments(new ClientPortalDocumentFiltersModel()));
  }, [thunkDispatch]);

  return (
    <DashboardCard
      key={1}
      title="Your Important Documents"
      icon={faFileContract}
      isBusy={loadingDocuments}
      bodyContent={
        <div>
          <DashboardCardValueContent
            value={documents?.length ? documents.filter((d) => d.important).length : 0}
            text={"Important documents to view"}
          />
        </div>
      }
      button={{ link: "/Documents?important=true", text: "View Documents" }}
      data-test-id="dashboard__view-documents-link"
    />
  );
};

export default YourDocumentsCard;
